import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const statusBadgeVariants = cva(
  'inline-flex items-center rounded-full border border-solid px-2.5 py-0.5 text-xs font-semibold',
  {
    variants: {
      variant: {
        success: 'border-[#abefc6] bg-[#ecfdf3] text-[#027a48]',
        warning: 'border-[#fedf89] bg-[#fffaeb] text-[#b54708]',
        info: 'border-[var(--inv-accent)] bg-[var(--inv-accent)] text-[var(--inv-on-accent)]',
        danger: 'border-[#fecdca] bg-[#fef3f2] text-[#b42318]',
        'info-outlined':
          'border-[var(--inv-border)] bg-[var(--inv-surface)] text-[var(--inv-text-secondary)]',
        'primary-outlined':
          'border-[var(--inv-accent)] bg-transparent text-[var(--inv-accent)]',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  },
);

export interface StatusBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusBadgeVariants> {
  value: string;
}

function StatusBadge({
  className,
  variant,
  value,
  ...props
}: StatusBadgeProps) {
  return (
    <span className={cn(statusBadgeVariants({ variant }), className)} {...props}>
      {value}
    </span>
  );
}

export { StatusBadge, statusBadgeVariants };
